export default {
	0: "toExpire",
	1: "liquidated",
	2: "notOpting",
	3: "debtor",
	4: "unavailable",
	5: "inInstallment"
};
